import { takeLatest } from "redux-saga/effects";
import { getCredentials } from "../../StateManagement/Reducers/LoginState";

import { LoginCheck } from "./LoginSagaWorkers";

export function* LoginSaga() {
  yield takeLatest(getCredentials.type, LoginCheck);
}
